import { useCallback, useState } from "react";
import { Seo } from "@/components/site/Section";
import { SignIn } from "@/components/account/SignIn";
import { MyAccount } from "@/components/account/MyAccount";
import { getToken, saveToken, clearToken } from "@/lib/api";

export default function Account() {
  const [token, setToken] = useState(getToken());
  const signOut = useCallback(() => {
    clearToken();
    setToken(null);
  }, []);
  const signedIn = (t) => {
    saveToken(t);
    setToken(t);
  };
  return (
    <>
      <Seo title="My Account" noindex path="/account" description="Sign in to My WeeLogRun to manage your firewood subscription." />
      {token ? <MyAccount onSignOut={signOut} /> : <SignIn onSignedIn={signedIn} />}
    </>
  );
}
